import { ReactElement } from 'react';
import { isEmpty } from 'lodash';

import { TooltipText } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { calendarTranslationKeys } from '../../../translations';

import { StyledRolesText } from './PractitionerResourceLabelContent.styled';

type DoctorSpecialtiesProps = {
   specialties: string[];
};

export const DoctorSpecialties = (props: DoctorSpecialtiesProps): ReactElement => {
   const specialties = props.specialties.join(', ');
   const noSpecialties = isEmpty(specialties);
   return (
      <TooltipText
         testId={'specialties'}
         lines={2}
         content={
            <ul>
               {props.specialties.map((specialty) => (
                  <li key={specialty}>{specialty}</li>
               ))}
            </ul>
         }
      >
         <StyledRolesText testId={'specialties'}>
            {noSpecialties ? <Translate>{calendarTranslationKeys.practitioner.noSpecialties}</Translate> : specialties}
         </StyledRolesText>
      </TooltipText>
   );
};
